import styled from "styled-components";

const MainGrid = styled.main`
  width: 100%;
  grid-gap: 0px; //distância entre os grids 
  margin-left: 0px;
  margin-right: auto;
  margin-bottom: auto;
  align-content: center;
  max-width: 500px;
  padding: 16px;
  @media(min-width: 860px) { //quando o tamanho da tela for de pelo menos 860px, vai definir essas colunas
    max-width: 1110px;
    display: grid;
    //grid-template-areas: "profileArea welcomeArea profileRelationsArea";
    grid-template-columns: 132px 65px 132px 65px 132px 65px 132px 65px 132px 65px 132px 65px 132px;
  }
`;

export default MainGrid;